/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VueMoment from "vue-moment";
import UUID from "vue-uuid";
import VueVirtualScroller from "vue-virtual-scroller";
import Echo from "laravel-echo";
import { VueHammer } from "vue2-hammer";
import moment from "moment";

import App from "./App.vue";
import Routes from "./routes";
import store from "./stores";
import filters from "./filters";
import httpAxios from "./axios";

import "./lib/css/app.css";

// Mixins
import Search from "@/mixins/SearchMixin";
import GlobalHelpers from "@/mixins/GlobalHelpersMixin";

// Components
import WdButton from "@/modules/input/components/WdButton.vue";
import IconBase from "@/modules/icons/components/IconBase.vue";
import Loading from "@/modules/core/components/Loading.vue";
import i18n from "./i18n";

if (process.env.VUE_APP_ECHO == "true") {
  if (process.env.NODE_ENV === "development") {
    console.info("LARAVEL ECHO is active!");
  }

  if (
    process.env.VUE_APP_ECHO_HOST.indexOf("http://") === 0 ||
    process.env.VUE_APP_ECHO_HOST.indexOf("https://") === 0
  ) {
    console.error(
      "Please correct your environment setting. http:// or https:// are not allowed in the environment key."
    );
  }

  if (process.env.VUE_APP_ECHO_TYPE === "socket") {
    window.io = require("socket.io-client");
    window.Echo = new Echo({
      broadcaster: "socked.io",
      host:
        (process.env.VUE_APP_ECHO_HOST
          ? process.env.VUE_APP_ECHO_HOST
          : "localhost") +
        ":" +
        (process.env.VUE_APP_ECHO_PORT
          ? process.env.VUE_APP_ECHO_PORT
          : "6001"),
      authEndpoint:
        (process.env.VUE_APP_ECHO_SSL == "true" ? "https:" : "http:") +
        "//" +
        (process.env.VUE_APP_ECHO_HOST
          ? process.env.VUE_APP_ECHO_HOST
          : "localhost") +
        (process.env.NODE_ENV === "development" &&
        process.env.VUE_APP_ECHO_HOST === "localhost"
          ? ":8897"
          : "") +
        "/broadcasting/auth",
      auth: {
        headers: {
          Authorization:
            "Bearer " + (localStorage.token ? localStorage.token : ""),
          Accept: "application/json",
        },
      },
    });
  } else if (process.env.VUE_APP_ECHO_TYPE === "pusher") {
    window.Pusher = require("pusher-js");
    window.Echo = new Echo({
      broadcaster: "pusher",
      host:
        (process.env.VUE_APP_ECHO_HOST
          ? process.env.VUE_APP_ECHO_HOST
          : "localhost") +
        ":" +
        (process.env.VUE_APP_ECHO_PORT
          ? process.env.VUE_APP_ECHO_PORT
          : "6001"),
      key: process.env.VUE_APP_ECHO_PUSHERKEY
        ? process.env.VUE_APP_ECHO_PUSHERKEY
        : "",
      cluster: "eu",
      forceTLS: true,
      encrypted: true,
      authEndpoint:
        (process.env.VUE_APP_ECHO_SSL == "true" ? "https:" : "http:") +
        "//" +
        (process.env.VUE_APP_ECHO_HOST
          ? process.env.VUE_APP_ECHO_HOST
          : "localhost") +
        (process.env.NODE_ENV === "development" &&
        process.env.VUE_APP_ECHO_HOST === "localhost"
          ? ":8901"
          : "") +
        "/broadcasting/auth",
      auth: {
        headers: {
          Authorization:
            "Bearer " + (localStorage.token ? localStorage.token : ""),
          Accept: "application/json",
        },
      },
    });
  }
}

Vue.config.productionTip = false;

/**
 * Registration
 */

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(UUID);
Vue.use(VueMoment);
Vue.use(VueVirtualScroller);
Vue.use(VueHammer);

VueHammer.config.pan = {
  direction: 6,
};
VueHammer.config.swipe = {
  direction: 6,
};

moment.locale("de-at");

Vue.prototype.$http = httpAxios;

// Global Mixins
Vue.mixin(Search);
Vue.mixin(GlobalHelpers);

// Global Components
Vue.component("wd-button", WdButton);
Vue.component("icon", IconBase);
Vue.component("loading", Loading);

// Custom Directives

Vue.directive("scroll", {
  inserted: function(el, binding) {
    let f = function(evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener("scroll", f);
      }
    };
    window.addEventListener("scroll", f);
  },
});

Vue.directive("in-viewport", {
  inserted: function(el, binding) {
    if(!!window.IntersectionObserver){
      el.observer = new IntersectionObserver((entries, observer) => { 
        entries.forEach(entry => {
        if(entry.isIntersecting){
          if (typeof binding.value === "function"){
            binding.value();
          }
          entry.target.src = entry.target.dataset.src;
          if (binding.modifiers.once){
            el.observer.unobserve(entry.target);
          }
        }
        });
      }, {threshold: binding.modifiers.full ? 1 : 0});
      el.observer.observe(el);
    }
  },
  unbind: function(el){
    el.observer.disconnect();
  }
});

/**
 * Register the Routes
 */

export const router = new VueRouter({
  mode: "history",
  routes: Routes,
});

const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (err) {
      // If there really is an error, throw it
      // Should probably be more sophisticated based on the type of err
      return Promise.reject(err);
    }
    // Otherwise resolve to false to indicate the original push call didn't go to its original
    // destination.
    return Promise.resolve(false);
  });
};

router.beforeEach((to, from, next) => {
  let isLogged = false;
  let token = null;

  let unsaved = store.getters["temp/unsaved"];

  if (Object.keys(unsaved).length > 0) {
    store.dispatch("dialog/add", {
      title: i18n.t("general.unsaved_work"),
      text: i18n.t("general.unsaved_work_message"),

      cancelFn: () => {
        return;
      },
      submitFn: () => {
        let destination = to;
        store.dispatch("temp/resetUnsaved");
        router.push(destination);
      },
    });
    return;
  }

  // Check if user account is required for the given state
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    token = store.getters["auth/token"];

    // Automatic language detection

    if (token === null) {
      next("/login");
      return;
    }

    if (to === from) {
      console.warn("Trying to navigate to same route: ", to);
      return;
    }

    isLogged = store.getters["auth/logged"];

    if (isLogged === false) {
      store
        .dispatch("auth/current")
        .then(() => {
          next();
        })
        .catch(() => {
          next("/login");
        });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((to, form, next) => {
  // Check if user account is required for the given state
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if user is logged
    let isLogged = store.getters["auth/logged"];
    if (isLogged === false) {
      next("/login");
      return;
    }

    let user = store.getters["auth/user"];
    let roles = to.meta.roles !== undefined ? to.meta.roles : [];
    let permissions =
      to.meta.permissions !== undefined ? to.meta.permissions : [];

    if (roles.length > 0 || permissions.length > 0) {
      // Sort
      user.roles.sort();
      user.permissions.sort();

      if (
        roles.length > 0 &&
        Search.binarySearch(roles, user.roles) === -1 &&
        permissions.length > 0 &&
        Search.binarySearch(permissions, user.permissions) === -1
      ) {
        router.push("/403");
        return;
      }
    }
  }
});

/**
 * Init application
 */

// eslint-disable-next-line
const app = new Vue({
  el: "#app",
  components: { App },
  router,
  store,
  i18n,

  mounted() {
    // Set the current Bearer token
    Vue.prototype.$http.defaults.headers.common["Authorization"] =
      store.getters["auth/token"] !== null
        ? "Bearer " + store.getters["auth/token"]
        : "";

    // Get the current logged user
    if (
      store.getters["auth/token"] !== undefined &&
      store.getters["auth/token"] !== null
    ) {
      store
        .dispatch("auth/current")
        .then(() => {
          // Do nothing with the response
        })
        .catch(() => {
          this.$store.dispatch("auth/logged", false);
          this.$store.commit("auth/logged", false);
          router.go();
        });
    }

    this.$http.interceptors.response.use(undefined, function(err) {
      return new Promise(() => {
        if (err.status === 401) {
          let popupParams = {
            type: "info",
            title: i18n.t("general.auth.logged_out_title"),
            text: i18n.t("general.auth.logged_out_message"),
          };
          store.dispatch("popup/addPopup", popupParams);
          this.$store.dispatch("auth/logout");
        }
        throw err;
      });
    });
  },
});
